import React from 'react';
import { compose } from '@cube3/state/src/utils/component-helpers';
import { withCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { Link, matchPath, useLocation, withRouter } from 'react-router-dom';
import Logo from '@cube3/cubicle/src/core/atoms/Logo/Logo';

const WorkspaceLogo = ({ currentWorkspace, alt, src, autoWidth }) => {
  const match = matchPath<{ shareToken: string }>(
    useLocation().pathname,
    '/share-link/:shareToken'
  );

  const share = match && match.params.shareToken;

  let path = '/';

  if (currentWorkspace) {
    path = `/workspace/${currentWorkspace.id}/`;
  }

  if (share) {
    path = `/share-link/${share}`;
  }

  return (
    <div>
      <Link to={path}>
        <Logo
          autoWidth={autoWidth}
          alt={
            alt ||
            (currentWorkspace && `${currentWorkspace.display_name} logo`) ||
            'Cube logo'
          }
          src={
            src ||
            (currentWorkspace &&
              currentWorkspace.display_image +
                '?updated_at=' +
                currentWorkspace.updated_at)
          }
        />
      </Link>
    </div>
  );
};

export default compose(WorkspaceLogo)(withRouter, withCurrentWorkspace);
